import { reaction, runInAction } from "mobx"

import { withGlobalLoader } from "@/lib/context.ts"

import type { GlobalContext } from "@/lib/context.ts"
import type { Lifetime } from "@/lib/Lifetime.ts"
import type { IObservableValue } from "mobx"

export async function submitGeneric(params: {
  submit: () => Promise<void>
  context: GlobalContext,
  canSubmit?: IObservableValue<boolean>,
  isSubmitting?: IObservableValue<boolean>,
  error?: IObservableValue<string | null>,
  validate?: () => Promise<string | null>,
}) {
  const { error, validate, submit, isSubmitting, context, canSubmit } = params

  if (canSubmit && !canSubmit.get()) {
    return
  }

  runInAction(() => {
    if (isSubmitting) {
      isSubmitting.set(true)
    }
  })

  try {
    if (validate) {
      const validationError = await validate()

      if (validationError) {
        if (error) {
          runInAction(() => {
            error.set(validationError)
          })
        }
        return
      }
    }

    await withGlobalLoader(context, submit())
  } finally {
    runInAction(() => {
      if (isSubmitting) {
        isSubmitting.set(false)
      }
    })
  }
}

export function resetErrorOnChange(lifetime: Lifetime, error: IObservableValue<string | null>, prop: IObservableValue<unknown>) {
  lifetime.add(reaction(() => {
    return prop.get()
  }, () => {
    error.set(null)
  }), "resetErrorOnChange")
}